export default __webpack_public_path__ + "static/media/Unit_19_thumb.92390018.jpg";